import { Box, Link } from "@mui/material";
import TkButton from "../../../components/atoms/TkButton";
import "../_style.scss";
import { TkGetCode } from "../../../utils/TkGetCode";
import { HandleStatus } from "../../../assets/data/Constants";
import { AgentRequestList } from "../../../type/apiType/IAPI_AGE005";

function handleGetbodyList(
  res: AgentRequestList[],
  handleRerequest: any,
  handleReferenceRequest: any,
  handleClick: any,
  handleRequestCancelClick: any // Modified to use handleRequestCancelClick
) {
  return res.map((item) => [
    {
      id: item.taskId,
    },
    {
      children: (
        <TkButton
          onClick={() => {
            handleRerequest(item);
          }}
          disabled={item.handleStatus === "3"}
        >
          再依頼
        </TkButton>
      ),
      align: "center",
    },
    {
      children: item.name,
    },
    {
      children: item.facilityName,
    },
    {
      children: (
        <Box className="agentContent">
          <TkButton
            onClick={() => {
              handleReferenceRequest(item);
            }}
            disabled={
              item.handleStatus !== "3" || item.formerTaskTypeCd === "5"
            }
          >
            参照依頼
          </TkButton>
          <Box className="content">
            <Link
              data-testid="SCRC100001Link"
              onClick={() => {
                handleClick(item);
              }}
            >
              {item.formerTaskType}
            </Link>
          </Box>
        </Box>
      ),
    },
    {
      children: TkGetCode(HandleStatus, item.handleStatus),
    },
    {
      children: item.taskCreateDate,
      align: "center",
    },
    {
      children: item.dueDate,
      align: "center",
    },
    {
      children: item.latestHandleDate ? (
        item.latestHandleDate
      ) : (
        <TkButton
          onClick={() => {
            handleRequestCancelClick(item); // Modified to use handleRequestCancelClick
          }}
        >
          依頼取消
        </TkButton>
      ),
      align: "center",
    },
  ]);
}

export { handleGetbodyList };
